import type React from 'react';

function MicrosoftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 371 371"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Microsoft Icon</title>

      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_2-2" data-name="Layer 2-2">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <rect width="371" height="371" fill="none" />
          </g>
        </g>
        <g>
          <path
            d="M92.76,192.97c28.02,0,56.03,0,84.05-.02,.93,0,1.23,.16,1.23,1.18-.03,56.03-.03,112.07,0,168.1,0,.93-.23,1.16-1.16,1.16-56.03-.02-112.07-.02-168.1,0-.9,0-1.18-.18-1.18-1.14,.03-56.03,.03-112.07,0-168.1,0-.99,.26-1.2,1.22-1.2,27.98,.03,55.97,.02,83.95,.02Z"
            fill="#05a5ef"
          />
          <path
            d="M278.13,363.34c-27.98,0-55.97,0-83.95,.02-.96,0-1.22-.21-1.22-1.2,.03-56,.03-112,0-168.01,0-.98,.24-1.2,1.21-1.2,56,.03,112,.03,168.01,0,1,0,1.32,.29,1.21,1.22-.03,.25,0,.51,0,.77,0,55.68,0,111.36,0,167.04,0,1.56,.17,1.39-1.39,1.39-27.95,0-55.91,0-83.86,0v-.03Z"
            fill="#feb908"
          />
          <path
            d="M178.02,92.86c0,27.99,0,55.97,.02,83.96,0,.94-.18,1.22-1.19,1.22-56.04-.03-112.07-.03-168.11,0-.95,0-1.14-.26-1.14-1.17,.02-55.94,.02-111.88,.02-167.82q0-1.4,1.4-1.4c19.47,0,38.94,0,58.41,0,36.44,0,72.87-.02,109.31-.02,1.47,0,1.27-.16,1.27,1.29,0,27.99,0,55.97,0,83.96Z"
            fill="#f25325"
          />
          <path
            d="M363.36,92.95c0,27.92,0,55.84,0,83.76,0,1.5,.17,1.29-1.27,1.29-55.97,0-111.94,0-167.91,.02-.93,0-1.22-.17-1.22-1.18,.03-56,.03-112,.03-168.01,0-1.36-.17-1.21,1.25-1.21,55.36,0,110.72,0,166.08,0,.61,0,1.22-.01,1.83,0,1.23,.01,1.23,.01,1.23,1.28,0,21.85,0,43.7,0,65.54v18.51h-.02Z"
            fill="#80bb06"
          />
        </g>
      </g>
    </svg>
  );
}

export default MicrosoftIcon;
